/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
import verified from '@assets/images/check.png';

function Badge({
  type, tier, tierIcon, width,
}) {
  return (
    <>
      {type === 1
            && (
              <>
                {tier === 'Featured'

                  ? (
                    <img src={verified} width={width} alt='badge' />
                  )

                  : (
                    <>
                      {tierIcon
                    && (
                      <img src={tierIcon} width={width} alt='badge' />
                    )}
                    </>
                  )}

              </>
            )}

    </>
  );
}

Badge.defaultProps = {
  width: '22px',
};

export default Badge;
